import { Component, OnInit } from '@angular/core';
import { Supplier } from 'src/app/models/supplier';
import { SupplierService } from 'src/app/services/supplier.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {AuthService } from 'src/app/services/auth.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.css']
})
export class SupplierComponent implements OnInit {
  suppliers:Supplier[] = [];
  suppliersTemp:Supplier[] = [];
  public addSupplier: boolean = true;
  public upSupplier: boolean = true;
  public deleSupplier: boolean = true;
  public loading = false;
  public expand:boolean = false;
  public supplier:Supplier = new Supplier();
  //Pagination
  public page:number = 1;
  public pagination:number = 20;
  //Searching
  public find:string = '';

  constructor(private servSupp:SupplierService, private modalService: NgbModal, private autServ: AuthService, private utl:UtilitiesService, private toastr: ToastrManager) { }

  async ngOnInit() {  //optener permisos con el AuthService
    await this.getSuppliers();
    this.addSupplier = this.autServ.can("store-supplier");
    this.upSupplier = this.autServ.can("update-supplier");
    this.deleSupplier = this.autServ.can("destroy-supplier");
  }

  async getSuppliers(){
    this.loading = true;
    this.suppliers = await this.servSupp.getSuppliers();
    this.filter();
    this.loading = false;
  }

  filter(){
    this.utl.search(this.suppliers, ['id', 'business_name', 'rfc', 'street', 'zip_code', 'contact_name', 'email'], this.find, 'id', suppliers => this.suppliersTemp = suppliers);
  }

  select(modal?, supplier?:Supplier) {
    if(supplier) {
      this.supplier = supplier;
    } else {
      this.supplier = new Supplier();
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  async storeSupplier() {
      try {
        this.loading = true;
        let supplier = await this.servSupp.postSupplier(this.supplier);
        this.find = '';
        await this.getSuppliers();
        this.modalService.dismissAll();
        this.loading = false;
        this.toastr.successToastr('El proveedor fue creado correctamente', '', {enableHTML: true});
      } catch (e) {
        this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML: true});
        this.loading = false;
      }
  }

  async updateSupplier() {
    try {
      this.loading = true;
      let supplier = await this.servSupp.putSupplier(this.supplier);
      this.find = '';
      await this.getSuppliers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El proveedor fue actualizado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
      this.loading = false;
    }
  }

  async deleteUser() {
    try {
      this.loading = true;
      let supplier = await this.servSupp.deleteSupplier(this.supplier);
      this.find = '';
      await this.getSuppliers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El proveedor fue eliminado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
      this.loading = false;
    }
  }

  rfcFormat(){
    if(this.supplier.rfc){
      this.supplier.rfc = this.supplier.rfc.trim().toLocaleUpperCase();
    }
  }

  postalCodeFormat(){
    if(this.supplier.zip_code){
      this.supplier.zip_code = this.supplier.zip_code.trim();
    }
  }
}
